import { BillingCycle, IProductEntity, PlanType } from '@/features/common/pricing';
import { IProductMetadata, ProductMetadataFeature } from './entities/ProductMetadata';
import { CustomProductMetadataBuilder } from './ProductMetadataBuilder/CustomProductMetadataBuilder';
import { FreeProductMetadataBuilder } from './ProductMetadataBuilder/FreeProductMetadataBuilder';
import {
  ProductMetadataBuilder,
  PRODUCT_METADATA_FEATURES_BY_ORDER,
} from './ProductMetadataBuilder/ProductMetadataBuilder';
import { ProPlusProductMetaBuilder } from './ProductMetadataBuilder/ProPlusProductMetaBuilder';
import { ProProductMetadataBuilder } from './ProductMetadataBuilder/ProProductMetadataBuilder';
import { UnlimitedProductMetadataBuilder } from './ProductMetadataBuilder/UnlimitedProductMetadataBuilder';

interface PlanMetadataBuilderCostructor {
  new (products: IProductEntity[], cycle: BillingCycle): ProductMetadataBuilder;
}

export class PricingUseCase {
  public getProductsMetadata(
    products: IProductEntity[],
    billingCycle: BillingCycle,
  ): IProductMetadata[] {
    const planTypes = this.getOrderedPlanTypes(products);

    return planTypes.map((planType: PlanType) => {
      const planTypeProducts = products.filter((p) => p.family === planType);
      const Builder = this.resolvePlanBuilder(planType);
      const builder = new Builder(planTypeProducts, billingCycle);
      return builder.build();
    });
  }

  public getPlanProductMetadataAllAvailableFutures(): ProductMetadataFeature[] {
    return PRODUCT_METADATA_FEATURES_BY_ORDER;
  }

  private resolvePlanBuilder(planType: PlanType): PlanMetadataBuilderCostructor {
    const builders = {
      [PlanType.Free]: FreeProductMetadataBuilder,
      [PlanType.Pro]: ProProductMetadataBuilder,
      [PlanType.ProPlus]: ProPlusProductMetaBuilder,
      [PlanType.Unlimited]: UnlimitedProductMetadataBuilder,
      [PlanType.Custom]: CustomProductMetadataBuilder,
    };
    return builders[planType];
  }

  private getOrderedPlanTypes(products: IProductEntity[]): PlanType[] {
    const uniqFamilies = new Set(products.map((product) => product.family));
    uniqFamilies.add(PlanType.Custom);
    return Array.from(uniqFamilies);
  }
}
